<template>
	<div class="header">
		<div class="content c-md">
			<a href="/" class="logo">
				<img src="../assets/images/logo.png">
				<span><img src="../assets/images/CMIClogo.png"></span>
			</a>

			<div class="menus c-md">
				<el-menu
					mode="horizontal"
					text-color="#FFFFFF"
					active-text-color="#FFFFFF"
					:default-active="defaultActive"
					:router="true"
					>
					<el-menu-item index="/index">首页</el-menu-item>
					<el-menu-item index="/cma/2020-2021">CMA2020&2021</el-menu-item>
					<el-menu-item index="/cma/finalist">历届</el-menu-item>
					<el-menu-item index="/cma/introduce">唱工委</el-menu-item>
					<el-menu-item index="/cma/contact">加入我们</el-menu-item>
				</el-menu>
				<a href="http://cma.cmicawards.org.cn" class="btn" target="_blank">进入评选系统</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'Mheader',
		data () {
			return {
				defaultActive: '/index'
			}
		},
		mounted() {
			this.defaultActive = this.$route.path;
		},
		methods:{
			
		},
		watch:{
			$route() {
				this.defaultActive = this.$route.path;
			}
		}
	}
</script>
<style lang="scss" scope>
	.header{
		position: relative;
		height: 100px;
		// background: #181413;

		.content {
			margin: 0 auto;
			padding: 0 20px;
			width: 1200px;
			height: 100%;
			overflow: hidden;
			// background: #181413;
		}
		.logo{
			display: inline-block;
			height: 50px;
			vertical-align: middle;
			>img{
				// width: 100%;
				height: 100%;
				vertical-align: middle;
			}
			span{
				display: inline-block;
				vertical-align: middle;
				margin-left: 40px;
			}
		}
		.menus {
			float: right;
			height: 100px;
		
			.btn {
				display: inline-block;
				margin-left: 25px;
				width: 132px;
				height: 40px;
				background:  #CD1E77;
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #FFFFFF;
				border-radius: 30px;
				vertical-align: middle;
			}
			.el-menu{
				display: inline-block;
				height: 60px;
				border:0;
				background-color: transparent;
				vertical-align: middle;

				.el-menu-item {
					margin: 0 25px;
					padding: 0;
					height: 60px;
					line-height: 60px;
					background-color: transparent !important;
					font-size: 16px;
					&:hover {
						// color: #CD1E77 !important;
						background-color: transparent !important;
					}
					&.active{
						background-color: transparent;
					}
				}
			}
		}
		
	}

</style>